export const MessageTypes = {
    Success: 'Success',
    Error: 'Error',
    Info: 'Information'
}
export const ToastrMessages = {
    ///Addtional Request page
    AddtionalRequest_Success_Msg: 'User role details have been successfully saved',
    AddtionalRequest_Default_Homepage: 'The default setup is applied to the Home page',

    ///Access Management page
    AccessMgt_Success_Msg: 'User roles approved successfully',
    AccessMgt_Reject_Msg: 'User roles rejected successfully',

    ///User Adminsitration page
    UserMgt_Success_Msg: 'User roles saved successfully',
    UserMgt_Status_Success_Msg: 'User status updated successfully'
}

//Verification module
export const ImageVerificationStatus = {
    SUCCESS: 'Yes',
    REJECTED: 'No',
}
export const VerificationMessage = {
    IMG_MSG_SUCCESS: 'Image verified successfully',
    IMG_MSG_REJECTED: 'Image verification rejected successfully',

    STORE_VERIFICATION_CONFIRMATION_HEADER: "Store Verification",
    STORE_VERIFICATION_CONFIRMATION: 'Are you sure you want to mark this store as verified? Once confirmed, you will not be able to edit the results.',
    STORE_MSG_SUCCESS: 'Store verification completed successfully',
    PROJECTREPORT_UPLOAD_SUCCESS: 'Project Report file uploaded successfully',
    PROJECTREPORT_INVALID_EXCEL: 'The provided Excel file does not contain the expected format',
    PROJECTREPORT_DOWNLOAD_SUCCESS: 'Project Report file downloaded successfully.',
    PROJECTREPORT_DOWNLOAD_FAILED: 'Failed to download Project Report',
    PROJECTREPORT_OVERWRITE_DATENOTSELECTED: 'Please select dates to overwrite',

    PROJECT_VERIFICATION_NOTEXISTS: "At this moment there are no verification in the system.",
    PROJECT_VERIFICATION_CONFIRMATION_HEADER: "Project Verification",
    PROJECT_VERIFICATION_CONFIRMATION: 'Are you sure you want to mark this project as verified? Once confirmed, you will not be able to edit the results.',
    PROJECT_VERIFICATION_SUCCESS: "Project verified successfully",

}

export const StoreVerificationStatus = {
    COMPLETED: 'Completed'
}

export const Verification = {
    ProjectStatus: ["Pending - Verification Start", "Pending - File Processing", "In Progress", "Verified"],
    ProjectReportStatus: ["PENDING", "PROCESSED", "VERIFIED"]
}

export const VerificationStatus = {
    PENDING_VERIFICATION_START: 'Pending - Verification Start',
    PENDING_FILE_PROCESSING: 'Pending - File Processing',
    IN_PROGRESS: 'In Progress',
    VERIFIED: 'Verified'
}

export const MaterialRMSConstants = {
    MaterialRMS_Add: 'RMSAdd',
    MaterialRMS_Remove: 'RMSRemove',
    MaterialRMS_Update: 'RMSUpdate'
}

export const NewlyAddedProductsConstants = {
    Product_Category: 'Please select at least one category to add a new product.',
    Product_Fields: 'Product description, ITEM#, and UPC are required for all newly added products.',
}

export const RolesKeysConstants = {
    RoleKey_ITAdmin: 'IT',
    RoleKey_SREAdmin: 'SA',
    RoleKey_SRESupport: 'SS',
    RoleKey_CustomerTeam: 'CT',
    RoleKey_AgencyUser: 'AU',
}

export class AgencyReportConstants {
    static getAgencyConstants(agency: string) {
        switch (agency) {
            case 'Acosta':
                return {
                    sheetName: 'Fixture',
                    requiredColumns: ['Store Nbr', 'Call Completed', 'URL'],
                    //headerRowIndex: 0
                };
            case 'Anderson':
                return {
                    sheetName: 'Photo',
                    requiredColumns: ['Store Number', 'Date', 'Photos'],
                    //headerRowIndex: 1,
                };
            case 'Field Agent':
                return {
                    sheetName: 'Zevo Photo Audit',
                    requiredColumns: ['Store Number'],
                    //headerRowIndex: 0,
                };
            default:
                return {
                    sheetName: '',
                    requiredColumns: [],
                    headerRowIndex: 0
                };
        }
    }
}

export class ApprovalConstants {
    public static readonly Approval_RequestForReview: string = "REQUEST APPROVAL";
    public static readonly Approval_Approved: string = "APPROVED";
    public static readonly Approval_ACTIONREQUIRED: string = "ACTION REQUIRED";
    public static readonly Approval_LOCKED: string = "LOCKED";
    public static readonly Approval_UNLOCKED: string = "UNLOCKED";
}
export const ValidationCriteriaConstants = {
    Criteria_Text: 'Please enter criteria for selected response type.',
    Response_Type: 'Please select response type for criteria.',
    Response_Saved_Message: 'Responses saved successfully',
    Response_Delete_Message: 'Responses reverted successfully',
    Response_EmptyError_Message: 'At least one ISO Response must be entered.',
    Duplicate_Criteria: 'Duplicate criteria text is not allowed for dropdown response type.'
}

export class ProductMasterConstants {
    static getProductUploadConstants() {
        return {
            sheetName: 'Export',
            requiredColumns: ['Cust Vendor Number', 'Sector', 'Sub Sector', 'Cust Department Sub Category',
                'Cust UPC Barcode', 'Cust Item Number', 'Cust Item Description', 'PG Std Product Name'
            ],
        };
    }
}
export class StoreMasterConstants {
    static getStoreUploadConstants() {
        return {
            sheetName: 'Export',
            requiredColumns: ['CUSTOMER', 'STORE NUMBER', 'TDLINX', 'STORE NAME',
                'STREET', 'CITY', 'STATE', 'ZIP CODE', 'PHONE'
            ],
        };
    }
}

export const ProductMessageConstants = {
    PRODUCT_UPLOAD_SUCCESS: 'Products file uploaded successfully',
    PRODUCT_PARTIAL_UPLOAD_SUCCESS: 'Partial Products uploaded. Please check the downloaded error file for details.',
    PRODUCT_INVALID_EXCEL: 'The provided Excel file does not contain the expected format',
}
export const StoreMessageConstants = {
    STORE_UPLOAD_SUCCESS: 'Stores file uploaded successfully',
    STORE_PARTIAL_UPLOAD_SUCCESS: 'Partial Stores uploaded. Please check the downloaded error file for details.',
    STORE_INVALID_EXCEL: 'The provided Excel file does not contain the expected format',
}
export const NotificationMessage = {
    REQUIRED_CUSTOMER_SUPPORT: 'Please select at least one recipient in "To Customer Support".',
    REQUIRED_SUBJECT: 'Please enter Subject.',
    REQUIRED_MESSAGE: "Please enter Message.",
    REMINDEREMAIL_SENT_SUCCESS: 'Reminder email sent successfully.',
}